import React from "react";

const AuditCell = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Audit Cell</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <p>
          Internal Audit Section is headed by Sr. F&amp;AO(IAD) with supporting
          staff of one A.O., one Accounts Clerk, one clerk and one Jr.Scale
          Stenographer. As per decision of BOD the work of Internal Audit has
          been outsourced and entrusted to Raj Har Gopal &amp; co., Chartered
          Accountants, Dehli with effect from 1.10.2010. The Internal Audit to
          be conducted on half yearly basis.
        </p>

        <h6>
          The scope of Internal Audit is highlighted below:
        </h6>

        <ol>
          <li>
            Internal Audit at the units will cover all aspects / areas for
            efficient working with least cost and to check the leakages,
            pilferages at all the levels particulars at plants / stores of
            Corporation and suggest further measures to strengthen the system.
          </li>
          <li>
            Identification of areas of significant inefficiencies in existing
            system and to suggest necessary remedial measures.
          </li>
          <li>
            Compliance of all policies, procedures, instructions, guidlines and
            orders issued to the units by Head Office from time to time.
            Compliance of all statutory requirments under Income Tax and other
            statutory laws by the units.
          </li>
          <li>
            Review of targets vis-a-vis achievements in respect of production
            and marketing with short fall and deficiencies therein.
          </li>
          <li>
            Review of preformance of various functions undertaken at the units
            and to suggest cost reduction measures, if any.
          </li>
          <li>
            Periodical stock and assets verifications for reporting the
            deficincy in its proper maintenance.
          </li>
          <li>
            Examinations of various existing internal control system and giving
            suggestions for improvement, if any.
          </li>
          <li>
            Review of the expenditures incurred at the units with the budget
            allocation. and report of the variation, if any.
            <br />
            &nbsp;
          </li>
        </ol>

        <p>
          The Internal Auditor after conducting their audit, forward their
          Internal Audit Report to the Unit Incharges and Sr.F&amp;AO(IAD), Head
          Office for necessary replies/actions with a copy to Head Office. While
          conducting the audit for subsequent period the compliance report on
          the audit observations pointed out in the report relating to earlier
          audit is mentioned in audit report of subsequent period. The Internal
          Auditor also submits complaince report to the M.D./Sr.F&amp;AO(IAD).
        </p>

        <p>
          The main observations of Internal Audit Reports are placed before the
          Board of Directors of HSDC and copies of audit reports are sent to the
          nominee of Finance Department on Board of HSDC as per State Govt.
          instructions.
        </p>
      </div>
    </div>
  );
};

export default AuditCell;
